// extracted by mini-css-extract-plugin
export var btn = "profileDetailPopup-module--btn--75704";
export var close = "profileDetailPopup-module--close--97c62";
export var input = "profileDetailPopup-module--input--6dad5";
export var overlay = "profileDetailPopup-module--overlay--45553";
export var para = "profileDetailPopup-module--para--47702";
export var popup = "profileDetailPopup-module--popup--d6a3c";
export var section = "profileDetailPopup-module--section--9f75d";
export var text = "profileDetailPopup-module--text--3782c";